// components/tables/AdminAdditionalTablesTable.jsx
import { useQuery, useQueryClient } from "react-query";
import { useApplication } from "../../contexts/ApplicationContext";
import { useState } from "react";
import { ADMIN } from "../../config/apiConfig";
import { Badge, Button, Pagination, Table } from "flowbite-react";
import { IoMdAdd, IoMdSearch } from "react-icons/io";
import { FaArrowsLeftRight } from "react-icons/fa6";
import { FaRegEdit } from "react-icons/fa";
import axios from "../../config/axiosInstance";
import EmptyTable from "./EmptyTable";
import TableLoading from "../TableLoading";
import Drawer from "../Drawer";
import AdditionalTableQueriesForm from "../forms/AdditionalTableQueriesForm";

const AdminAdditionalTablesTable = () => {
  const queryClient = useQueryClient();
  const { user } = useApplication();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [type, setType] = useState("CREATE");
  const [selectedTable, setSelectedTable] = useState(null);

  const onPageChange = (page) => setCurrentPage(page);

  const { isLoading, data: listAdditionals } = useQuery(
    ["listAdditionalTables", currentPage, nameParam],
    async () => {
      const { data } = await axios.get(
        `${ADMIN.GET_ALL_ADDITIONAL_TABLES}?page=${currentPage}&search=${nameParam}`
      );

      setTotalPages(data.data.totalPages || 1);
      setTotalCount(data.data.totalCount || 0);

      return data.data;
    }
  );

  const handleSearch = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const handleEdit = (table, type) => {
    setType(type);
    setSelectedTable(table);
    setIsDrawerOpen(true);
  };

  return (
    <>
      <div className="flex justify-end mb-3 mt-2">
        <Button
          className="bg-primary"
          variant="contained"
          onClick={() => handleEdit(null, "CREATE")}
        >
          <IoMdAdd className="block md:hidden text-2xl" />
          <span className="hidden md:block">Criar tabela adicional</span>
        </Button>
      </div>

      <form
        className="flex gap-1 mt-5 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
        onSubmit={handleSearch}
      >
        <input
          type="text"
          placeholder="Buscar por nome..."
          className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
          onChange={(e) => setSearchName(e.target.value)}
          value={searchName}
        />
        <Button
          size="sm"
          className="flex items-center bg-secondary w-20"
          type="submit"
        >
          <IoMdSearch />
        </Button>
      </form>

      {listAdditionals?.length > 0 || isLoading ? (
        <>
          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>
            <FaArrowsLeftRight />
          </small>
          <div className="overflow-x-auto shadow-md rounded-lg mt-0 md:mt-5">
            <Table striped className="text-xs xl:text-sm">
              <Table.Head>
                <Table.HeadCell className="text-center bg-gray-300">
                  Tabela
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-300">
                  Ações
                </Table.HeadCell>
              </Table.Head>

              <Table.Body className="divide-y">
                {!isLoading ? (
                  listAdditionals.map((table, index) => (
                    <Table.Row
                      key={index}
                      className="bg-white dark:border-gray-700 dark:bg-gray-800"
                    >
                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-1">
                        {table.name}
                      </Table.Cell>
                      <Table.Cell className="text-center py-1">
                        <div className="flex gap-2 justify-center items-center">
                          <Button
                            className="p-0 bg-primary"
                            onClick={() => handleEdit(table, "EDIT")}
                          >
                            <FaRegEdit fontSize="16" />
                          </Button>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))
                ) : (
                  <TableLoading cols={4} />
                )}
              </Table.Body>
            </Table>
          </div>

          {totalCount > 0 && (
            <div className="mt-3 text-center text-sm">
              Foram encontrados {totalCount} registros no total
            </div>
          )}

          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-3">
              <Pagination
                layout="pagination"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                previousLabel=""
                nextLabel=""
                showIcons
              />
            </div>
          )}
        </>
      ) : (
        <EmptyTable icon="search_off">
          Nenhuma tabela adicional encontrada
        </EmptyTable>
      )}

      <Drawer
        title={`${type === "CREATE" ? "Criar" : "Editar"} Tabela Adicional`}
        onClose={setIsDrawerOpen}
        isOpen={isDrawerOpen}
        className="w-full md:w-4/6 lg:w-2/6"
      >
        <AdditionalTableQueriesForm
          selectedTable={selectedTable}
          onClose={setIsDrawerOpen}
          fetchTables={() => {
            queryClient.invalidateQueries(["listAdditionalTables"]);
          }}
          type={type}
          isAdditional // Você pode usar essa flag dentro do TableQueriesForm para diferenciar
        />
      </Drawer>
    </>
  );
};

export default AdminAdditionalTablesTable;
